import React, { createContext, useContext, useEffect } from 'react';
import { ITracer } from 'app/tracing/tracing';
import { ILogger } from 'app/tracing/logging';
import { UnityUtils } from 'app/unity/UnityUtils';
import { UnityRequests } from 'app/unity/UnityRequests';
import { MapTileFetcher } from 'app/tiling/MapTileFetcher';
import { UnityNotificationListener } from 'app/unity/UnityNotificationListener';

import { NMUI4DServiceFactory } from './NMUI4DServiceFactory';
import EventBus from '../eventbus/EventBus';
import { FlightEnricher } from '../util/FlightEnricher';

export type NMUI4DContextProps = {
    logger: ILogger;
    tracer: ITracer;
    unityUtils: UnityUtils;
    unityRequests: UnityRequests;
    flightEnricher: FlightEnricher;
    isMapless: boolean;
    mapTileFetcher: MapTileFetcher;
    eventBus: EventBus;
    unityNotificationListener: UnityNotificationListener;
};

export const NMUI4DContext = createContext<NMUI4DContextProps>(null);

export const NMUI4DContextInitializer = () => {
    const context = useContext(NMUI4DContext);

    useEffect(() => {
        const service = new NMUI4DServiceFactory();

        context.logger = service.getLogger();
        context.tracer = service.getTracer();

        context.unityUtils = service.getUnityUtils();
        context.unityRequests = service.getUnityRequests();

        context.flightEnricher = service.getFlightEnricher();

        context.isMapless = new URLSearchParams(window.location.search).get('mode') === 'mapless';

        context.eventBus = service.getEventBus();

        context.unityNotificationListener = service.getUnityNotificationListener();

        context.mapTileFetcher = service.getMapTileFetcher();
    }, []);

    return <></>;
};
